import { copy } from "../content/copy";
import { useScrolled } from "../hooks/useScrolled";
import { useTheme } from "../hooks/useTheme";
import { trackEvent } from "../lib/analytics";
import { Button } from "./Button";
import { NicheHireLogo } from "./NicheHireLogo";
import { ThemeToggle } from "./ThemeToggle";

export function Nav() {
  const scrolled = useScrolled(8);
  const { theme } = useTheme();

  return (
    <header className={`nav${scrolled ? " nav--scrolled" : ""}`}>
      <div className="container nav__inner">
        <a className="nav__brand" href="#top" aria-label="NicheHire home">
          <NicheHireLogo size={36} variant={theme === "dark" ? "light" : "default"} />
        </a>
        <nav className="nav__links" aria-label="Primary">
          {copy.nav.links.map((link) => (
            <a key={link.href} href={link.href} className="nav__link">
              {link.label}
            </a>
          ))}
        </nav>
        <div className="nav__actions">
          <ThemeToggle />
          <Button
            as="a"
            href="#join"
            variant="orange"
            onClick={() => trackEvent("cta_click", { location: "nav" })}
          >
            {copy.nav.cta}
          </Button>
        </div>
      </div>
    </header>
  );
}
